import React from "react";
import { createPortal } from "react-dom";
import { Button } from "../Button/Button";

export interface AlertDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonType?:
    | "primary"
    | "secondary"
    | "danger"
    | "warning"
    | "info"
    | "light"
    | "dark";
  width?: string;
  showCancelButton?: boolean;
}

export const AlertDialog: React.FC<AlertDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = "ALERT!",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonType = "primary",
  width = "500px",
  showCancelButton = true,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return createPortal(
    <div
      className="modal-backdrop"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "24px",
          maxWidth: width,
          width: "90%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        }}
      >
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div className="my-3">
            <i className="bi bi-exclamation-triangle-fill fs-5 me-2 text-danger"></i>
            <span className="fs-5 text-danger">{title}</span>
          </div>
          <p>{message}</p>
        </div>
        <div className="d-flex justify-content-center gap-2 w-100 align-items-center">
          {showCancelButton && (
            <Button type="outline-primary" onClick={onClose}>
              {cancelText}
            </Button>
          )}
          <Button type="primary" onClick={handleConfirm}>
            {confirmText}
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AlertDialog;
